export default __webpack_public_path__ + "static/Hw3DLogoScreenshot-ddb7c7e84c9ce49204bbbf795cefe498.png";